import { Breadcrumb } from "react-bootstrap";

import { type BreadcrumbProps } from "../MemberBreadcrumbs.types";

import BreadcrumbName from "./BreadcrumbName.component";

const TextBreadcrumb = ({ currentName }: BreadcrumbProps) => {
  return (
    <Breadcrumb.Item active>
      <BreadcrumbName currentName={currentName} />
    </Breadcrumb.Item>
  );
};

export default TextBreadcrumb;
